export function isKickStaffEmail(email: string | null | undefined): boolean {
    return email?.toLowerCase().endsWith("@kick.co") ?? false;
}
